import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
// import { Utility } from '../utils/utility';
import { interval, Subscription } from 'rxjs';
import { debounce, map } from 'rxjs/operators';
import { ValidationService } from './ValidationService';

/**
 * This component is using for common display messages for invalid inputType.
 */
@Component({
    selector: 'control-messages',
    standalone: true,
    imports: [CommonModule],
   template: `
    <div class="error" style="margin-top: 4px">
      <div *ngIf="errorMessage !== null">{{ errorMessage }}</div>
    </div>
  `,
    styleUrls: ['Input-control-messages.component.css']
})
export class InputControlMessagesComponent {
    @Input() control: any;
    @Input() inputElmControl: any;
    @Input() errors = [];
    formChangeSubscription: Subscription[] = [];

    constructor(private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        if (this.control) {
            this.formChangeSubscription.push(
                this.control.valueChanges.pipe(
                    debounce(() => interval(100))
                ).subscribe(() => {
                    this.cdr.detectChanges();
                })
            );
        }
    }


    public isUndefined(value: any) {
        if (value === void 0) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * This function is returning error message.
     * @returns {any}
     */
    get errorMessage(): any {
        if (!this.isUndefined(this.control)) {
            for (const propertyName in this.control.errors) {
                if (this.control.errors.hasOwnProperty(propertyName) && this.control.dirty) {
                    return ValidationService.getValidatorErrorMessage(
                        propertyName,
                        this.control.errors[propertyName],
                        this.control.errors,
                        this.inputElmControl
                    );
                }
            }
            return null;
        } else if (this.errors) {
            for (const propertyName in this.errors) {
                return ValidationService.getValidatorErrorMessage(
                    propertyName,
                    this.errors[propertyName],
                    this.errors,
                    this.inputElmControl
                );
            }
        }
    }

    ngOnDestroy() {
        this.formChangeSubscription.forEach(subscription => subscription.unsubscribe());
    }
}
